<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import { get } from "svelte/store"
	import LoadState from "../../Enums/LoadState";

	export let boundaries = [];
	export let filterString = "";
	export let height = 300;

	let style = "height:"+height+"px;min-height:"+height+"px;";

	const dispatch = createEventDispatcher(); // update
</script>

<div class="maritime-boundaries-table-container mdc-elevation--z2" style={style}>
	<table class='svelte-table'>
		<thead>
			<tr>
				<th>Name</th>
				<th width="40">Type</th>
				<th width="60">Visible</th>
			</tr>
		</thead>
		<tbody>
			{#each boundaries as boundary (boundary.uniqId)}
				{#if (filterString.trim().length === 0 ||
					boundary.name.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)}
					<tr>
						<td>{boundary.name}</td>
						<td>{boundary.type}</td>
						<td>
							{#if get(boundary.loadState) === LoadState.LOADING}
								Loading...
							{:else}
								<button
									class={(get(boundary.visible)?"bg-primary":"bg-info")}
									style="font-size:12px;"
									on:click={()=>{
										boundary.visible.set(!get(boundary.visible));
										dispatch("update");
									}}
									>{get(boundary.visible)}</button>
							{/if}
						</td>
					</tr>
				{/if}
			{/each}
		</tbody>
	</table>
</div>
